import { useFormikContext } from "formik";

import { Grid} from "@mui/material";

import Field from "../../../utils/FormikFields/Field";

const Stock = () => {
  const { values } = useFormikContext() || {};

  let disabled = !values?.brand_name
  return (
    <>
      <Grid item size={{xs: 12, lg: 4}}>
        <Field name="min_stock" label="Low Stock Alert" type="number" disabled={disabled} />
      </Grid>
    </>
  )
};

export default Stock;